import { NotificationService } from '@sine/sine-ui-components';

/**
 * @deprecated Do not use directly! Use the `useNotification` hook instead.
 */
const notificationService = new NotificationService();
export default notificationService;
